import { render, staticRenderFns } from "./LayoutGrupoDetalheForm.vue?vue&type=template&id=cab1cdfe"
import script from "./LayoutGrupoDetalheForm.vue?vue&type=script&lang=js"
export * from "./LayoutGrupoDetalheForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports